export enum OBreadcrumbType {
  TopBorder = 'Top Border',
  NoBorder = 'No Border',
  BottomBorder = 'Bottom Border',
}

export interface OBreadcrumbProps {
  type: OBreadcrumbType;
  mBreadcrumbGroup: {
    backButton?: boolean | string | null;
    mButton?: OBreadcrumbBackButton;
    mBreadcrumbMulti?: Array<{
      aTextInteractive: {
        text: string;
        ctaLink?: string | null;
        custom_click_track_value?: string;
      };
    }>;
  };
  trackingProperties?: Record<string, unknown>;
}

export interface OBreadcrumbBackButton {
  buttonText?: string | null;
  ctaLink?: string | null;
  openInANewTab?: string | null;
}
